// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1kWsP","filesListContainer":"PosDisputesFiles_filesListContainer__2wAp4","filesButton":"PosDisputesFiles_filesButton__FWid4"};